export const callbackRequestCtaClick = {
    event: "callback_request_cta_click",
    eventCategory: "b2c_callback_request_flow",
    eventAction: "callback_request_cta_click"
};
